import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import User from '../views/User.vue'
import Player from '../views/Player.vue'
import Admin from '../views/Admin.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'Home',
        component: Home
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/user',
        name: 'User',
        component: User
    },
    {
        path: '/purchased',
        name: 'Purchased',
        component: () => import('../views/Purchased.vue')
    },
    {
        path: '/player',
        name: 'Player',
        component: Player
    },
    {
        path: '/admin',
        name: 'Admin',
        component: Admin
    },
    {
        path: '/payment-result',
        name: 'PaymentResult',
        component: () => import('../views/PaymentResult.vue')
    },
    {
        path: '/cashier',
        name: 'Cashier',
        component: () => import('../views/Cashier.vue')
    },
    {
        path: '/payment-processing',
        name: 'PaymentProcessing',
        component: () => import('../views/PaymentProcessing.vue')
    },
    {
        path: '/payment-debug',
        name: 'PaymentDebug',
        component: () => import('../views/PaymentDebug.vue')
    }
]

const router = new VueRouter({
    routes
})

export default router
